export default __webpack_public_path__ + "static/media/pull-push-gray-icon.d48916db.svg";